require('./items.less');

class ItemsController {
    items;
    defaultSearchParams = {pageSize:100, pageNo: 0, sort:""};
    activeSearchParams = {pageSize:100, pageNo: 0, sort:""};

    searchDefinition ={
        fields:[
            {title:'Vare', name: 'text', type:'text'},
        ],
        searchParams: Object.assign({}, this.defaultSearchParams),
        searchFunction:(params)=> this.itemsSearch(params),
    };

    toolbarheaderDefinition = {
        isTable: true,
        toolbarHeading: "Søk etter varer",
        buttons: [
            {func: () => this.searchDefinition.searchParams = Object.assign({}, this.defaultSearchParams), tooltip: "Slett søkedata", materialicon: "delete_sweep"},
        ],
    };

    tableDefinition={
        columns: [
            {title:'Varenummer', name: 'id', noOrderBy: true},
            {title:'Varenavn', name: 'name', noOrderBy: true},
            {title:'Enhet', name: 'unit', noOrderBy: true},
            {title:'Hovedlokasjon', name: 'defaultLocation', noOrderBy: true},
        ],
        settings:{
            editFunction: (ev, item) => this.openItemCard(ev, item),
            onPaginate: (page, limit)=> this.changePage(page, limit),
            promise: null,
            totalElements: null,
            initialPageSize: 11,
            title: 'Vareoversikt'
        }
    };

    constructor(private toastService, private Items, private $location, private $state){
    }

    $onInit() { }

    itemsSearch (params) {
        this.activeSearchParams = params;
        this.tableDefinition.settings.promise = this.Items.getItems(params).$promise.then(
            (results) => {
                this.items = results.content;
                this.tableDefinition.settings.totalElements = results.totalElements;
            }, (error) => {
                this.toastService.parseError(error);
            }
        )
    };

    changePage(page, limit){
        this.activeSearchParams.pageNo = page - 1;
        this.activeSearchParams.pageSize = limit;
        this.$location.search(this.activeSearchParams);
    }

    openItemCard(event, item) {
        this.$state.go("loggedin.expedition_basicdata_items_itemdetails", {itemId: item.id})
    }
}

class ItemsOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "rkcItemsController";
    public template: any = require('./items.html');
}

rkcApp.controller("rkcItemsController", ['toastService', 'Items', '$location', '$state', function(toastService, Items, $location, $state){
    return new ItemsController(toastService, Items, $location, $state);
}])
    .component("rkcItems", new ItemsOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/items/items.ts
 **/